<template>
  <aside class="sidebar">
    <div class="brand">
      <div class="logo-circle">PK</div>
      <span class="brand-text">Pooyesh Kids</span>
    </div>

    <nav class="menu">
      <a href="/dashboard" class="item">
        <span class="icon">📊</span>
        <span>داشبورد والدین</span>
      </a>
      <a href="/dashboard/rooms" class="item">
        <span class="icon">🎮</span>
        <span>اتاق‌های بازی</span>
      </a>
      <div class="divider"></div>
      <a href="/dashboard/settings" class="item">
        <span class="icon">⚙️</span>
        <span>تنظیمات</span>
      </a>
      <a href="/dashboard/help" class="item">
        <span class="icon">❓</span>
        <span>راهنما</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <div class="ad-card">
        <span class="ad-icon">⭐</span>
        <div class="ad-text">
          <strong>نسخه پریمیوم</strong>
          <p>دسترسی نامحدود</p>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default { name: 'SidebarMenu' }
</script>

<style scoped>
.sidebar {
  /* width: 260px; */
  background: #fff;
  border-left: 1px solid #f1f5f9;
  /* height: 100vh; */
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
  padding-right: 8px;
}
.logo-circle {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}
.brand-text {
  font-size: 20px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.5px;
}

.menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #64748b;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s;
  font-size: 15px;
}
.item:hover {
  background: #f8fafc;
  color: #1e293b;
  transform: translateX(-4px);
}
.item.active {
  background: #eff6ff;
  color: #2563eb;
}
.item.active .icon {
  transform: scale(1.1);
}

.icon {
  font-size: 20px;
  transition: transform 0.2s;
}

.divider {
  height: 1px;
  background: #f1f5f9;
  margin: 12px 0;
}

.sidebar-footer {
  margin-top: auto;
}
.ad-card {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #bae6fd;
}
.ad-icon { font-size: 24px; }
.ad-text strong { display: block; color: #0c4a6e; font-size: 14px; margin-bottom: 2px; }
.ad-text p { margin: 0; color: #0284c7; font-size: 12px; }
</style>
